module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ch-title_toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_vm._v("The House of Mapuhi")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Whale Tooth")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mauki")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Yah! Yah! Yah!”")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heathen")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Terrible Solomons")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inevitable White Man")])]), _vm._v(" "), _c('h2', {
    staticClass: "list1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seed of McCoy")]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0